import * as Icons from "@nova/component-icons"

export const NotListedIcon = () => {
    return <Icons.SmallIcon Icon={Icons.NotListedLocation} className="text-orange-500" />
}

export const BrightnessAlertIcon = () => {
    return <Icons.SmallIcon Icon={Icons.BrightnessAlert} className="text-red-500" />
}

export const BeenHereIcon = () => {
    return <Icons.SmallIcon Icon={Icons.BeenHere} className="text-green-500" />
}

export const DangerousIcon = () => {
    return <Icons.SmallIcon Icon={Icons.Dangerous} className="text-blue-200" />
}

export const CommentIcon = () => {
    return <Icons.SmallIcon Icon={Icons.Chat} />
}
